import { makeStyles } from "tss-react/mui";
import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";

export const useStyle = makeStyles()((theme) => {
    const mobileBreakpoint = getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE);

    return {
        phoneRow: {
            flexWrap: "nowrap",
            [mobileBreakpoint]: {
                flexWrap: "wrap",
                justifyContent: "flex-start",
            },
        },
        phoneRowInput: {
            flex: "1 1 auto",
            minWidth: 0,
            [mobileBreakpoint]: {
                flex: "1 1 100%",
            },
        },
        phoneRowButton: {
            flex: "0 0 auto",
            marginBottom: 0,
            marginTop: theme.spacing(3),
            [mobileBreakpoint]: {
                flex: "1 1 100%",
                width: "100%",
                margin: 0,
            },
        },
    };
});
